import { API_BASE_URL } from './api.config';

/**
 * Validación de token igual que en `gondola-billing-engine`: el JWT de Góndola viaja en
 * una cookie que pone el gateway; el **gateway es quien valida** la firma/expiración. El
 * front solo adjunta el token y, si el gateway lo rechaza (401), fuerza re-login.
 */

/** Cookie donde el gateway de Góndola deja el JWT de sesión. */
export const GONDOLA_COOKIE = 'gondola_session';

/** Clave de `sessionStorage` donde el gateway deja el usuario autenticado. */
export const SESSION_USER_KEY = 'auth_user';

/**
 * Origen del gateway de Góndola (gestiona el login). Se deriva de `API_BASE_URL` para no
 * duplicar el host — CLAUDE.md §servicios: la URL del backend vive solo en `api.config.ts`.
 * A este origen se redirige cuando el token es rechazado (401).
 */
export const GATEWAY_URL = new URL(API_BASE_URL).origin;
